<script>
export default {
  name: 'has-filters',
  computed: {
    currentViewNameForFilters () {
      let name = this.$options.name + '-' + this.$route.path.replace(/[^a-z0-9]/gmi, '');

      if (this.popupFilter) {
        name += '-' + this.popupFilter;
      }

      if (this.popupStatus) {
        name += '-' + this.popupStatus;
      }

      return name;
    }
  },
  data () {
    return {
      initialFilterValues: {}
    };
  },
  beforeMount () {
    if (!this.disableFiltersInSubview) {
      this.initialFilterValues = JSON.parse(JSON.stringify(this.filters));
      this.loadFilters();
    }
  },
  mounted () {
    if (!this.disableFiltersInSubview) {
      this.$bus.$on('view-filters-save', this.saveFilters);
      this.$bus.$on('view-filters-reset', this.resetFilters);
    }
  },
  methods: {
    loadFilters () {
      if (!localStorage.getItem('headwear-crm-filters-' + this.currentViewNameForFilters)) {
        this.resetFilters();
        return;
      }

      let filtersData = JSON.parse(localStorage.getItem('headwear-crm-filters-' + this.currentViewNameForFilters));

      if (this.currentViewNameForFilters === 'notifications-powiadomienia') {
        let loadedData = JSON.parse(JSON.stringify(filtersData));
        this.filters = Object.assign(this.initialFilterValues, loadedData);
      } else {
        this.filters = JSON.parse(JSON.stringify(filtersData));
      }
    },
    saveFilters () {
      localStorage.setItem('headwear-crm-filters-' + this.currentViewNameForFilters, JSON.stringify(this.filters));
    },
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.initialFilterValues));
      this.saveFilters();
    }
  },
  beforeDestroy () {
    if (!this.disableFiltersInSubview) {
      this.$bus.$off('view-filters-save', this.saveFilters);
      this.$bus.$off('view-filters-reset', this.saveFilters);
    }
  }
}
</script>
